function handleAccordions() {
  document.querySelectorAll('.js-accordion').forEach(accordion => {
    accordion.addEventListener('click', () => {
      if (accordion.classList.contains('open')) {
        accordion.classList.remove('open');
        accordion.setAttribute('aria-expanded', 'false');
      } else {
        accordion.classList.add('open');
        accordion.setAttribute('aria-expanded', 'true');
      }
    })
  })
}

function handleMobileMenu() {
  document.querySelectorAll('#header-shop-btn-new').forEach(button => {
    button.addEventListener('click', () => {
      let isExpanded = button.getAttribute('aria-expanded') == 'true';
      document.querySelectorAll(`#${button.getAttribute('aria-controls')}`).forEach(menu => {
        let shade = document.querySelector('#mobile-menu-shade');
        if (!isExpanded) {
          // When the modal is shown, we want a fixed body
          document.body.style.position = 'fixed';
          document.body.style.top = `-${window.scrollY}px`;

          menu.style.display = 'block';
          if (shade) shade.style.display = 'block';
          setTimeout(() => { 
            menu.classList.add('visible'); 
            button.setAttribute('aria-expanded', 'true'); 
          }, 10);
        } else {
          const scrollY = document.body.style.top;
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
          menu.classList.remove('visible');
          setTimeout(() => { 
            menu.style.display = 'none';
            if (shade) shade.style.display = 'none';
            button.setAttribute('aria-expanded', 'false'); 
          }, 1000);
        }
      })
    })
  });
  document.querySelectorAll('#mobile-menu-close').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll(`#${button.getAttribute('aria-controls')}`).forEach(menu => {
        let shade = document.querySelector('#mobile-menu-shade');
        menu.classList.remove('visible');
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        setTimeout(() => { 
          menu.style.display = 'none';
          if (shade) shade.style.display = 'none';
          document.querySelectorAll(`#${menu.getAttribute('aria-labelledby')}`).forEach(menu => menu.setAttribute('aria-expanded', 'false'));
        }, 1000);
      })
    })
  })
}

function handlePredictiveSearch() {
  document.querySelectorAll('.header__menu-link--search').forEach(button => {
    button.addEventListener('click', () => {
      document.body.style.overflow = 'hidden';
      document.querySelectorAll('predictive-search').forEach(form => {
        form.classList.remove('hidden');
        form.querySelector('input').focus();
      })
      document.querySelectorAll('main').forEach(main => {
        main.classList.add('blur');
      })
      document.querySelectorAll('.header').forEach(header => {
        header.classList.remove('animate');
        header.classList.add('no-animate');
      })
      document.querySelectorAll('input#Search[type=search]').forEach(input => {
        input.addEventListener('keypress', e => {
          if (e.key === "Enter") {
            e.preventDefault();
            document.querySelector('predictive-search button.predictive-search__item.predictive-search__item--term').click();
          }
        })
      })
      document.querySelectorAll('predictive-search button.close').forEach(x => {
        x.addEventListener('click', (e) => {
          e.preventDefault();
          document.querySelectorAll('predictive-search').forEach(form => {
            form.classList.add('hidden');
            form.querySelector('input').value = '';
            form.querySelector('input').textContent = '';
          })
          document.querySelectorAll('main').forEach(main => {
            main.classList.remove('blur');
          })
          document.querySelectorAll('.header').forEach(header => {
            header.classList.add('animate');
            header.classList.remove('no-animate');
          })
          document.body.style.overflow = 'visible';
          document.querySelector('#predictive-search').innerHTML = null;
        })
      })
    });
  })
}

function animatedTitle() {
  if (document.querySelector('.js-alternative-document-title')) {
    const newTitle = document.querySelector('.js-alternative-document-title').dataset.text;
    if (newTitle.length > 0) {
      let textAnimation = newTitle[0];
      document.title = textAnimation;
      window.titleInterval = setInterval(() => {
        if (textAnimation.length < newTitle.length) {
          textAnimation = newTitle.substring(0, textAnimation.length + 1);
          while (textAnimation[textAnimation.length - 1] == ' ') {
            textAnimation = newTitle.substring(0, textAnimation.length + 1);
          }
        } else {
          textAnimation = newTitle[0];
        }
        document.title = textAnimation;
      }, 500);
    }
  }
}

function staticTitle() {
  if (window.titleInterval) clearInterval(window.titleInterval);
  document.title = window.originalTitle;
}

function handleTitleAnimation() {
  window.originalTitle = document.title;
  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState == 'hidden') animatedTitle();
    else staticTitle();
  });
}

function customScripts() {
  handleAccordions();
  handleMobileMenu();
  handlePredictiveSearch();
  handleTitleAnimation();
}

function customScript() {
  document.addEventListener('DOMContentLoaded', customScripts);
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
    } else {
      this.updateURL();
      this.renderProductInfo();
    }
    // console.log(this.currentVariant.id);
    document.querySelector(`input[type=radio]#variant-${this.currentVariant.id}`).checked = true;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = "price";
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementsByClassName(id)[0];
        const source = html.getElementsByClassName(id)[0];
        const swatchDestination = document.querySelector('.js product-form__input.options');
        const swatchSource = html.querySelector('.js product-form__input.options');

        const price = document.getElementsByClassName('price')[0];

        if (price) {
          price.classList.remove('visibility-hidden');
          price.innerHTML = source.innerHTML;
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

customScript();
(function () {
  function replaceFilterLabels() {
    // Only touch spans inside typical filter/sidebar containers
    const containers = document.querySelectorAll(
      '.collection-filters, .facets, .sidebar, .filters, [class*="filter"], [id*="filter"]'
    );

    containers.forEach((root) => {
      root.querySelectorAll('span').forEach((el) => {
        if (el.children.length === 0) {
          const t = (el.textContent || '').trim();
          if (t === 'Price') el.textContent = 'Τιμή';
          if (t === 'Reset') el.textContent = 'Επαναφορά';
        }
      });
    });
  }

  // Run now + after AJAX/JS renders
  document.addEventListener('DOMContentLoaded', replaceFilterLabels);
  window.addEventListener('load', replaceFilterLabels);

  const mo = new MutationObserver(replaceFilterLabels);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
